export default "./dist/stdassets/images/icons/select-polygon.png";